<template>
  <div class="stats rc-view" :class="{ 'rc-width': setOpenMenuPanel }">
    <div class="opacity_gradient">
      <div v-if="!cargardatos">
        <v-container fluid>
          <v-layout wrap row class="mx-onboarding">
            <v-flex xs12 lg10 offset-lg1 pa-3 text-xs-center class="title-responsive">
              <h1><span>Mis operaciones</span></h1>
            </v-flex>

            <v-container fluid class="pa-0">
              <v-layout wrap row class="text-xs-right flex justify-end">
                <v-flex xs12 md2 mt-3>
                  <v-btn
                    class="rc-chip__ceder px-4 font-weight-medium text-capitalize mb-0 btn-rounded"
                    :to="{ name: 'dashboard-factoring-create-bussiness' }"
                    >Crear empresa</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>

            <v-flex xs12 mt-3 mb-5>
              <v-container style="border-radius: 25px;" fluid class="rc-shadow white rounded-lg elevation-3">
                <v-layout wrap row>
                  <v-flex xs12 md12 mb-2>
                    <p class="subheading mb-0">Selecciona tu empresa:</p>
                  </v-flex>

                  <v-flex xs12 md10>
                    <v-layout row wrap justify-start>
                      <v-flex xs12 sm12 md8 pr-2>
                        <BusinessSelect
                          class="myOperations-input2"
                          v-model="companySelected"
                          @rutempresa="rutempresa = $event"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 md2 px-3 v-if="businessCount > 0">
                    <v-btn
                      block
                      :to="{ name: 'dashboard-edit-business', params: { companyId: companySelected } }"
                      class="rc-chip__ceder text-capitalize btn-rounded"
                      >Editar</v-btn
                    >
                  </v-flex>

                  <v-container fluid pa-0 ma-0>
                    <v-layout>
                      <v-flex xs12 md12>
                        <p class="subheading mb-0">Filtros:</p>
                        <v-layout row wrap>
                          <v-flex xs12 md10>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md4>
                                <v-autocomplete
                                  v-model="documento_sol_factoring"
                                  label="Cantidad de documentos"
                                  :items="filters.documento_sol_factoring"
                                  multiple
                                  small
                                  clearable
                                  persistent-hint
                                  class="myOperations-input mt-2 border-text text-xs-center mr-1"
                                  outline solo
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-autocomplete
                                  v-model="date_solicitud_sol_factoring"
                                  label="Fecha de solicitud"
                                  :items="filters.date_solicitud_sol_factoring"
                                  multiple
                                  small
                                  clearable
                                  persistent-hint
                                  class="myOperations-input mt-2 border-text text-xs-center mr-1"
                                  outline solo
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-autocomplete
                                  v-model="state_sol_factoring"
                                  label="Estado"
                                  :items="filters.state_sol_factoring"
                                  multiple
                                  small
                                  clearable
                                  persistent-hint
                                  class="myOperations-input mt-2 border-text text-xs-center mr-1"
                                  outline solo
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-layout mt-2 row wrap>
                              <v-btn class="btn-filtro text-capitalize" block @click="resetFilters4">
                                Limpiar filtros
                              </v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-flex xs12 md12 lg12>
                    <v-container class="ma-0 px-0" fluid>
                      <v-layout row>
                        <div style="width: 100%;">
                          <div class="customTabs">
                            <v-btn
                              flat
                              v-for="(label, index) in tabLabels"
                              :key="index"
                              :class="['tab-btn', { 'active': currentTab === index }]"
                              @click="currentTab = index"
                            >
                              {{ label }}
                            </v-btn>
                          </div>
                          <div class="tab-content">
                            <div v-if="currentTab === 0">
                              <SolicitudFactoring
                                :empresa_id="companySelected"
                                :doc="documento_sol_factoring"
                                :fv="date_solicitud_sol_factoring"
                                :estado="state_sol_factoring"
                                :data="solicitudesConfirmadas"
                                mode="solicitudes"
                                :role="role_id"
                                @documentoSolFactoring="handleDocumentoOptions"
                                @solicitudFactoring="handleFechaOptions"
                                @estadoSolFactoring="handleEstadoOptions"
                              />
                            </div>
                            <div v-else-if="currentTab === 1">
                              <SolicitudFactoring
                                :empresa_id="companySelected"
                                :doc="documento_sol_factoring"
                                :fv="date_solicitud_sol_factoring"
                                :estado="state_sol_factoring"
                                :data="solicitudesPendientes"
                                mode="pendientes"
                                :role="role_id"
                                @documentoSolFactoring="handleDocumentoOptions"
                                @solicitudFactoring="handleFechaOptions"
                                @estadoSolFactoring="handleEstadoOptions"
                                @changeTab="handlerTabs"
                              />
                            </div>
                            <div v-else>
                              <SolicitudFactoring
                                :empresa_id="companySelected"
                                :doc="documento_sol_factoring"
                                :fv="date_solicitud_sol_factoring"
                                :estado="state_sol_factoring"
                                :data="solicitudesExpiradas"
                                mode="expiradas"
                                :role="role_id"
                                @documentoSolFactoring="handleDocumentoOptions"
                                @solicitudFactoring="handleFechaOptions"
                                @estadoSolFactoring="handleEstadoOptions"
                                @changeTab="handlerTabs"
                              />
                            </div>
                          </div>
                        </div>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-flex v-else xs12 text-xs-center pa-5>
        <v-progress-circular size="60" width="7" indeterminate color="primary" style="margin: 1.5rem" />
        <p class="pa-3 ma-0">Cargando Operaciones</p>
      </v-flex>
      <AlertSac />
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import API from "@/api";
import BusinessSelect from "@/components/dashboard/BusinessSelect.vue";
import ProjectStatus from "@/components/dashboard/ProjectStatusOn.vue";
import AlertSac from "@/components/AlertSac.vue";
import Resumen from "@/views/factoring/misOperaciones/tablaResumen.vue";
import SolicitudFactoring from "@/views/factoring/misOperaciones/Solicitudes_factoring.vue";

@Component({
  computed: {
    ...mapState(["user", "setOpenMenuPanel"]),
    setOpenMenuPanel() {
      return this.$store.state.openMenuPanel;
    },
  },
  watch:{
    async companySelected(newVal) {

      if(newVal && !this.firstLoad){
        this.role_id = this.getRole(this.staticBusiness);
        await this.getData(newVal);
      }
    },
  },  
  components: {
    BusinessSelect,
    ProjectStatus,
    AlertSac,
    Resumen,
    SolicitudFactoring,
  },
})
export default class Myoperations extends Vue {
  cargardatos = false;
  multibusiness = false;
  businesss = "";
  staticBusiness = [];
  businessCount = 0;
  companySelected = 0;
  documento_sol_factoring = "";
  date_solicitud_sol_factoring = "";
  state_sol_factoring = "";
  solicitud_factoring = [];
  rutempresa = null;
  currentTab = 0;
  tabLabels = ["Solicitudes Factoring", "Pendiente de aprobación", "Solicitudes expiradas"];
  filters = {
    id: "",
    name: "",
    date: "",
    state: "",
    rs: [],
    documento: [],
    date_vencimiento: "",
    state_factoring: "",
    cuotas_sol_credit: "",
    date_solicitud_sol_credit: "",
    state_sol_credito: "",
    documento_sol_factoring: [],
    date_solicitud_sol_factoring: [],
    state_sol_factoring: [],
  };
  role_id = null;
  firstLoad = true;
  

  get solicitudesConfirmadas() {
    return this.$data.solicitud_factoring.filter(s => s.confirmacion != 1 && s.expirada != 1);
  }
  get solicitudesPendientes() {
    return this.$data.solicitud_factoring.filter(s => s.confirmacion == 1 && s.expirada == 0);
  }
  get solicitudesExpiradas() {
    return this.$data.solicitud_factoring.filter(s => s.expirada == 1);
  }

  async beforeMount() {
    if (this.$store.state.businesSelected) {
      this.companySelected = this.$store.state.businesSelected.id;
      await this.getData(this.companySelected);
      this.firstLoad = false;
    }

    await this.getbusiness();
  }

  async getData(id) {
    try {
      this.solicitud_factoring = await API.solicitud_factoring(id);
    } catch (error) {
      console.error("Error al cargar solicitudes:", error);
    }
  }

  async getbusiness() {
    try {
      const res = await API.getBusiness();
      this.staticBusiness = res;
      this.businessCount = res.length;
      this.staticBusiness.unshift({ nombre: "CREAR EMPRESA", id: 0 });
      this.role_id = this.getRole(this.staticBusiness);
    } catch (error) {
      console.error("Error al cargar empresas:", error);
    }
  }

  handleDocumentoOptions(datos) {
    this.filters.documento_sol_factoring = datos;
  }

  handleFechaOptions(datos) {
    this.filters.date_solicitud_sol_factoring = datos;
  }

  handleEstadoOptions(datos) {
    this.filters.state_sol_factoring = datos;
  }
  async handlerTabs(tab_index){
    this.currentTab = tab_index;
    await this.getData(this.companySelected);
  }

  resetFilters4() {
    this.documento_sol_factoring = "";
    this.date_solicitud_sol_factoring = "";
    this.state_sol_factoring = "";
  }

  getRole(empresas){
    const selectedId = this.companySelected;
    if (!selectedId) return null;
    if (!empresas || !Array.isArray(empresas)) return null;
    const business = empresas.find(function (empresa) {
      return empresa.empresa_id === selectedId;
    });

    if(!business) return null;
    
    return business.user_role;
  }

}
</script>

<style lang="scss">

.myOperations-input{
    .v-input__control{
        align-content: center;
        .v-input__slot{
            .v-text-field__slot{  
                .v-label{
                    left: 0px;
                    right: auto;
                    position: absolute;
                    top: 5px;                    
                }    
                .v-label--active{
                    left: 0px;
                    right: auto;
                    position: absolute;
                    top: -2px;
                }
            }
            .v-select__slot{
                .v-label--active{
                    left: 0px;
                    right: auto;
                    position: absolute;
                    top: 0%;
                }
            } 
            .v-text-field__prefix {
                max-height: 2rem;
                margin-bottom: 10%;
            }
            
        }
        .v-input__slot input {
            margin-top: 0%;
        }  
        
        .v-input__append-inner{
            margin-top: 0px;
        }
        
    }
    @media (min-width: 601px){
        .v-input__control{
            .v-input__slot{
                height: 54px;
                min-block-size: fit-content;
                border-radius: 12px !important;
            }
        }
        
    }    
    @media (max-width:600px) {
        .v-input__control{
            .v-input__slot{
                height: 54px;
                min-block-size: fit-content;
                border-radius: 12px !important;
            }
        }
    }
}
.myOperations-input2{
    .v-input__control{
      .v-input__slot{
        .v-select__slot{
          top:-19%;
          .v-label--active{
            top:27%;
          }
          .v-label{
            margin-top: 0.5%;
          }
        }
        .v-input__append-inner{
          margin-top: 22px;
        }
      }

    }
    @media (min-width: 601px){
        .v-input__control{
            .v-input__slot{
                height: 54px;
                min-block-size: fit-content;
                border-radius: 12px !important;
            }
        }
        
    }    
    @media (max-width:600px) {
        .v-input__control{
            .v-input__slot{
                height: 54px;
                min-block-size: fit-content;
                border-radius: 12px !important;
            }
        }
    }
}
.rc-tabsItems{
  width: 100%;
}

.btn-rounded {
  border-radius: 25px !important;
}

.customTabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab-btn {
  padding: 30px 15px;
  background-color: #DBFFFC !important;
  border: none;
  border-radius: 27px 27px 0px 0px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0;
  text-transform: none !important;
  color: #19B2A3 !important;

  &:hover{
    background-color: #004646 !important;
    color: #fff !important;
  }
}

.tab-btn.active {
  background-color: #19B2A3 !important;
  color: #fff !important;
}

.tab-content {
  background-color: #ffffff;
  width: 100%;
}

.v-dialog {
  border-radius: 25px;
}
.btn-solicitar-select {
  background: linear-gradient(
    to bottom,
    rgba(248, 168, 74, 1) 0%,
    rgba(255, 143, 105, 1) 100%
  );
  border-radius: 25px;
  color: white !important;
  margin-bottom: 20px;
  padding: 0px 10px;
}
.btn-solicitar-select2 {
  background-color: #28efc8 !important;
  border-radius: 25px;
  color: white !important;
  margin-bottom: 20px;
  padding: 0px 10px;
}
.mx-onboarding {
  margin-left: 60px;
  margin-right: 60px;
}
.table-new {
  background-color: white;
  border-radius: 30px !important;
}
.table-new th {
  background-color: #F5F5F5 !important;
  color: #3d3d3d;
  padding: 10px 10px;
}
.table-new td {
  padding: 10px 10px;
  text-align: center;
  border-top: 1px solid #ddd;
}
.table-total {
  background-color: white;
  border-radius: 30px !important;
}
.table-total th {
  background-color: #F5F5F5 !important;
  color: white;
}
.table-total td {
  padding: 10px;
  text-align: left;
  border-top: 1px solid #ddd;
}
.table-total {
  background-color: white;
  border-radius: 30px !important;
}
.table-total th {
  background-color: #F5F5F5 !important;
  color: white;
}
.table-total td {
  padding: 10px;
  text-align: left;
  border-top: 1px solid #ddd;
}
.active-tabss3 {
  background-color: #f47828 !important;
  color: white !important;
  border-radius: 50px 50px 0px 0px !important;
  opacity: 1;
  font-weight: 700;
}
/*Media Queries */
@media screen and (max-width: 600px) {
  .mx-onboarding {
    margin-left: 0px;
    margin-right: 0px;
  }
  .title-responsive h1 {
    margin-top: 30px;
  }

  .customTabs {
    overflow-x: auto;
    flex-wrap: nowrap;
    justify-content: flex-start;
    scrollbar-width: none; 
  }

  .customTabs::-webkit-scrollbar {
    display: none; 
  }
}
</style>
